import { useTranslation } from 'next-i18next';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useState } from 'react';
import { Modal, Button } from '@components/common';

export interface DownloadPdfEvaluationModalProps {
  onConfirm: (includeEvaluation: boolean) => void;
}

export const DownloadPdfEvaluationModal = NiceModal.create((props: DownloadPdfEvaluationModalProps) => {
  const { onConfirm } = props;
  const { t } = useTranslation('common');
  const modal = useModal();
  const [includeEvaluation, setIncludeEvaluation] = useState(true);

  const closeModal = () => { void modal.hide(); };

  const handleDownload = () => {
    onConfirm(includeEvaluation);
    void modal.hide();
  };

  return (
    <Modal isOpen={modal.visible} onClose={closeModal} size="sm">
      <Modal.Header content={t('cv.action.pdf.evaluation.modal.title')} onClose={closeModal} />
      <Modal.Body className="bg-surface-50">
        <div className="space-y-4 p-6">
          <p className="text-sm text-ink-medium">
            {t('cv.action.pdf.evaluation.modal.description')}
          </p>
          <label className="flex cursor-pointer items-center gap-3">
            <input
              type="checkbox"
              className="size-4 rounded border-gray-300"
              checked={includeEvaluation}
              onChange={(e) => setIncludeEvaluation(e.target.checked)}
            />
            <span className="text-sm text-ink">
              {t('cv.action.pdf.evaluation.modal.checkbox')}
            </span>
          </label>
          <div className="flex justify-end gap-2 pt-2">
            <Button styling="outline" color="ink" size="md" onClick={closeModal}>
              {t('global.action.cancel')}
            </Button>
            <Button color="secondary" size="md" onClick={handleDownload}>
              {t('cv.action.pdf')}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export const showDownloadPdfEvaluationModal = (args: DownloadPdfEvaluationModalProps) => {
  void NiceModal.show(DownloadPdfEvaluationModal, args);
};
